import { render, staticRenderFns } from "./SchoolHistoryMuseumReservat.vue?vue&type=template&id=6efd4be3&scoped=true&"
import script from "./SchoolHistoryMuseumReservat.vue?vue&type=script&lang=js&"
export * from "./SchoolHistoryMuseumReservat.vue?vue&type=script&lang=js&"
import style0 from "./SchoolHistoryMuseumReservat.vue?vue&type=style&index=0&id=6efd4be3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efd4be3",
  null
  
)

export default component.exports